import React from "react";
import { PriceSliderProps } from "./PriceSliderProps";
import { WithCurrencyProps } from "../Currency/WithCurrencyProps";
import { withCurrency } from '../Currency/withCurrency';

const PriceSlider: React.FC<PriceSliderProps & WithCurrencyProps> = ({
    title,
    max,
    min,
    value,
    onChange,
    c
}) => {

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {value} = e.target;

        onChange(Number(value));
    }
    return (
        <React.Fragment>
            <div className="flex flex-col gap-2 justify-center items-center w-full">
                <label className="form-label">{title}</label>
                <label className="text-md italic">${c(value)}</label>
                <div className="flex flex-row gap-1 justify-center items-center w-full">
                    <span className="text-md italic">${c(min)}</span>
                    <input id="minValuePrice" className="w-full h-2 accent-custom-500" type="range" multiple={true} min={min} max={max} value={value} onChange={handleChange} />
                    <span className="text-md italic">${c(max)}</span>
                </div>
            </div>
        </React.Fragment>
    )
}

export default withCurrency(PriceSlider);